import { customAlphabet } from 'nanoid';

/**
 * Generates a unique reference ID for bank transfer payments.
 * Format: TRF-XXXXXXXXXX (prefix + 10 alphanumeric characters)
 *
 * This ID is used as the `providerReferenceId` when calling the bank transfer
 * integration APIs (ChytaPay, Cucuru) and is separate from the order ID.
 *
 * @returns A unique transfer reference ID (e.g., "TRF-A1B2C3D4E5")
 */
export const generateTransferReferenceId = (): string => {
  const nanoid = customAlphabet('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ', 10);

  return `TRF-${nanoid()}`;
};
